function hasLabels(entity) {
  return entity?.metadata?.labels ? Object.keys(entity?.metadata?.labels).some(Boolean) : false;
}

export { hasLabels };
//# sourceMappingURL=conditions.esm.js.map
